<template>
  <div class="hello">
    <van-tabbar active-color="#FF5733" inactive-color="#999999" v-model="active">
      <van-tabbar-item name="/" to="/">
        <span>首页</span>
        <img slot="icon" slot-scope="props" :src="props.active ? icon.tabbar1 : icon.tabbar1ed"/>
      </van-tabbar-item>
      <van-tabbar-item name="/activity" to="/activity">
        <span>志愿活动</span>
        <img slot="icon" slot-scope="props" :src="props.active ? icon.tabbar2 : icon.tabbar2ed"/>
      </van-tabbar-item>
      <van-tabbar-item name="/news" to="/news" >
        <span>消息通知 </span>
        <img slot="icon" slot-scope="props" :src="props.active ? icon.tabbar3 : icon.tabbar3ed"/>
      </van-tabbar-item>
      <van-tabbar-item name="/mine" to="/mine">
        <span>我的 </span>
        <img slot="icon" slot-scope="props" :src="props.active ? icon.tabbar4 : icon.tabbar4ed"/>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
export default {
  name: 'TabBar',
  props: {
    msg: String
  },
  data() {
    return {
      active: '/',
      icon: {
        tabbar1: require("@/assets/image/1.png"),
        tabbar1ed: require("@/assets/image/11.png"),
        tabbar2: require("@/assets/image/3.png"),
        tabbar2ed: require("@/assets/image/21.png"),
        tabbar3: require("@/assets/image/2.png"),
        tabbar3ed: require("@/assets/image/31.png"),
        tabbar4: require("@/assets/image/4.png"),
        tabbar4ed: require("@/assets/image/41.png"),
      },
    }
  },
  mounted() {
    this.active = this.$route.path
  },
  watch: {
    '$route': {
      handler() {
        this.active = this.$route.path
      },
      deep: true,
      immediate: true,
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.van-tabbar {
  height: 64px;
  background: linear-gradient(rgba(255, 255, 255, 0) 20%, rgba(255, 255, 255, 1) 30%);
}

.van-tabbar::after {
  border: none;
  box-shadow: 0 0 0px #f4f5f5;
}

.van-tabbar-item__icon img {
  height: 46px;
  width: 93.75px;
  margin-top: -19px;
  z-index: 3;
}

.van-tabbar-item--active {
  background-color: rgba(255, 255, 255, 0);
}
</style>
